import appCaptain from "../../views/appFleet/captain.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("captain", {
    url: "captain/:id",
    parent: "app",
    views: {
      view: {
        template: appCaptain,
      },
    },
    data: { title: "Captain" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/captain/captain.urls.js